/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { customAlphabet } from 'nanoid'
import { TRANSACTION_ID_RANDOM_LENGTH } from '../constants'

export const makeTxId = () => {
  const randomizer = customAlphabet('0123456789abcdef')
  const segmentPattern = /^(\w{12})(\w{4})(\w{4})(\w{8})$/gi
  const groups = segmentPattern.exec(randomizer(TRANSACTION_ID_RANDOM_LENGTH))

  if (!groups) {
    throw new Error('Failed to construct the transaction unique ID')
  }

  return groups.slice(1, groups.length).join('-')
}
